import { Link } from "react-router-dom";
import { CONTACT_EMAIL, CONTACT_WECHAT, SITE_NAME } from "@/utils/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="grid gap-10 px-4 py-12 md:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500">
              <i className="ri-play-circle-fill text-lg text-primary-950" aria-hidden="true"></i>
            </span>
            <span className="text-base font-bold text-background-50">{SITE_NAME}</span>
          </div>
          <p className="mt-4 text-sm leading-7 text-background-300">
            聚合中文字幕电影与电视剧内容，按题材、年份、地区分类整理，帮助你在几分钟内找到想看的那一部。全站内容为演示数据。
          </p>
        </div>

        <div>
          <h2 className="text-sm font-semibold text-background-50">快速导航</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">网站首页</Link></li>
            <li><Link to="/category/movie" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">电影频道</Link></li>
            <li><Link to="/category/tv" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">电视剧频道</Link></li>
            <li><Link to="/category/movie/filter" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">分类筛选</Link></li>
            <li><Link to="/about" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="text-sm font-semibold text-background-50">热门题材</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/search?q=悬疑" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">中文字幕悬疑片</Link></li>
            <li><Link to="/search?q=古装" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">古装剧在线观看</Link></li>
            <li><Link to="/search?q=都市" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">都市情感剧集</Link></li>
            <li><Link to="/search?q=战争" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">战争历史影视</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="text-sm font-semibold text-background-50">联系我们</h2>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            <li className="flex items-start gap-2">
              <span className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center"><i className="ri-mail-line text-sm text-accent-400" aria-hidden="true"></i></span>
              <span>{CONTACT_EMAIL}</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center"><i className="ri-wechat-line text-sm text-accent-400" aria-hidden="true"></i></span>
              <span>微信公众号：{CONTACT_WECHAT}</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center"><i className="ri-time-line text-sm text-accent-400" aria-hidden="true"></i></span>
              <span>内容反馈：工作日 10:00 - 18:00</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800 px-4 py-5 md:px-8">
        <div className="flex flex-col gap-2 text-xs leading-6 text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {SITE_NAME} · 本站为影视内容演示站点，不提供真实片源与下载服务。</p>
          <p>站内海报与信息均为演示素材，如涉及版权问题请联系我们处理。</p>
        </div>
      </div>
    </footer>
  );
}